import { action, reaction } from "mobx";
import { InputMode } from "../Types";
import {
  canvasViewport,
  canvasViewportShouldAnimateAtom,
  exposeZoomPrevViewportBox,
  inputModeComputed,
  paneKeyboardMappingAtom,
} from "./CanvasState";
import { FocusPaneEmitter } from "./FocusPane";
import { KeyboardCommandPriority, registerKeyboardCommand } from "./Keyboard";
import { setPaneKeyboardMapping } from "./PaneKeyboardSelector";
import { reactionOnCondition } from "./SandboxUtils";
import { zoomToFit } from "./ToolbarZoomButton";

export function setupExposeZoom() {
  return [
    registerKeyboardCommand({
      name: "enter expose",
      keys: ["Shift-F"],
      modes: [InputMode.Normal],
      handler: action(() => {
        exposeZoomPrevViewportBox.set({
          offset: [...canvasViewport.offset],
          zoom: canvasViewport.zoom,
        });
        setPaneKeyboardMapping();
        zoomToFit();
      }),
    }),
    reactionOnCondition(
      () => exposeZoomPrevViewportBox.get() !== undefined,
      () =>
        registerKeyboardCommand({
          name: "exit expose zoom",
          keys: ["Escape", "Shift-F"],
          modes: [InputMode.ExposeZoom],
          priority: KeyboardCommandPriority.High,
          handler: action(() => {
            const exposeZoomPrevViewport = exposeZoomPrevViewportBox.get()!;
            canvasViewportShouldAnimateAtom.value = true;
            canvasViewport.offset = exposeZoomPrevViewport.offset;
            canvasViewport.zoom = exposeZoomPrevViewport.zoom;
            exposeZoomPrevViewportBox.set(undefined);
          }),
        })
    ),
    reactionOnCondition(
      () => inputModeComputed.get() === InputMode.ExposeZoom,
      action(() =>
        registerKeyboardCommand({
          name: "select pane",
          keys: "*",
          priority: KeyboardCommandPriority.High,
          modes: [InputMode.ExposeZoom],
          handler: action((key) => {
            if (paneKeyboardMappingAtom.value !== undefined) {
              const entry = Object.entries(paneKeyboardMappingAtom.value).find(
                ([paneId, k]) => k === key
              );
              if (entry !== undefined) {
                const [paneId] = entry;
                zoomToFit([paneId]);
                exposeZoomPrevViewportBox.set(undefined);
                FocusPaneEmitter.emit("focus", { paneId });
              }
            }
            paneKeyboardMappingAtom.value = undefined;
          }),
        })
      )
    ),
    reaction(
      () => inputModeComputed.get() === InputMode.ExposeZoom,
      action((isExposeZoom) => {
        if (!isExposeZoom) {
          paneKeyboardMappingAtom.value = undefined;
        }
      })
    ),
  ];
}
